import { useFlags } from '~/hooks/utils/launchDarklyInterceptor';

/**
 * Flags that are permanent and not subject to change.
 *
 * If you need are adding a temporary flag, add it to `useTemporaryFlags` instead.
 */
export type FeatureFlags = {
  apiAccess: boolean;
  canManagePeople: boolean;
  canSeeAddOns: boolean;
  canGenerateManagedCdnLinks: boolean;
  excludedIntegrations?: string[];
  forceReload: boolean;
  hideShortUrlSignUpButton: string[];
  internalMenu: boolean;
  maintenanceModeJson: {
    maintenanceMessage: string;
    bannerMessage: string;
  };
  releaseVersion: string;
  selectWorkspaceAuth: {
    domains?: string[];
  };
  sessionDuration: boolean;
  showSharePointImportSource: boolean;
  versionsZipping: boolean;
  videoTimestamp: boolean;
  whiteLabelWorkspaces?: string[];
  /**
   * This controls Skip button visibility in the onboarding upload prompt
   * Should be true for sysadmin
   */
  skipOnboardingUpload: boolean;
  crossLocationSelectionEnabled: boolean;
  collectionsEnabled: boolean;
  hybridSemanticSearchEnabled: boolean;
  importHistoryEnabled: boolean;
};

export const useFeatureFlags = () => {
  return useFlags<FeatureFlags>();
};
